import React from 'react';

import {EntitlementsPagination} from 'src/modules/entitlements';

import {mcpEntitlementsStateActions, mcpEntitlementsStateSelector} from '../slices/mcp-entitlements-state.slice';

type Props = {
    totalCount: number,
};

export const McpEntitlementsPagination = ({totalCount}: Props) => (
    <EntitlementsPagination
        totalCount={totalCount}
        stateActions={mcpEntitlementsStateActions}
        stateSelector={mcpEntitlementsStateSelector}
    />
);
